import React, {Component} from 'react';

import {FadingOutDiv} from './styles';

class FadingOutEffect extends Component {
  render() {
    return <FadingOutDiv ref={this.props.innerRef} {...this.props} />;
  }
}

export default FadingOutEffect;
